module.exports = __webpack_public_path__ + "img/red_icon3.88734fa3.png";